<template>
  <table class="table table-sm mb-0">
    <tr v-if="!excludeFields.includes('first_name')">
      <td class="border-top-0 font-weight-bold">{{ $t('Customer') }}</td>
      <router-link v-if="enableCustomerLink && $hasPermission('view_customer')"
                   :to="{name: 'customers.view', params: {id: customer.uuid}}">
        <td class="border-top-0">{{ customer.customer_no }}</td>
      </router-link>
      <td v-else class="border-top-0">{{ customer.customer_no }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('accounting_code')">
      <td class="font-weight-bold">{{ $t('Accounting Code') }}</td>
      <td>{{ customer.accounting_code }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('first_name')">
      <td class="font-weight-bold">{{ $t('First Name') }}</td>
      <td>{{ customer.first_name }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('last_name')">
      <td class="font-weight-bold">{{ $t('Last Name') }}</td>
      <td>{{ customer.last_name }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('middle_name')">
      <td class="font-weight-bold">{{ $t('Middle Name') }}</td>
      <td>{{ customer.middle_name }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('company_name')">
      <td class="font-weight-bold">{{ $t('Company Name') }}</td>
      <td>{{ customer.company_name }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('is_company')">
      <td class="font-weight-bold">{{ $t('Is Company') }}</td>
      <td>
        <span v-if="customer.is_company" class="badge bg-success text-white">{{ $t('Yes') }}</span>
        <span v-else class="badge bg-danger text-white">{{ $t('No') }}</span>
      </td>
    </tr>
    <tr v-if="!excludeFields.includes('title')">
      <td class="font-weight-bold">{{ $t('Title') }}</td>
      <td>{{ customer.title | toUpperCaseFirst }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('personal_id')">
      <td class="font-weight-bold">{{ $t('Personal ID') }}</td>
      <td>{{ customer.personal_id }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('client_tier')">
      <td class="font-weight-bold">{{ $t('Client Tier') }}</td>
      <td><client-tier-display-widget :customer="customer" /></td>
    </tr>
    <tr v-if="!excludeFields.includes('email')">
      <td class="font-weight-bold">{{ $t('Email') }}</td>
      <td>
        <template v-if="customer.email">
          <span class="badge border mr-1">
            <a :href="`mailto:` + customer.email"> {{ customer.email }}</a>
          </span>
        </template>
      </td>
    </tr>
    <tr v-if="!excludeFields.includes('phone')">
      <td class="font-weight-bold">{{ $t('Phone') }}</td>
      <td>
        <template v-if="customer.phone">
          <span class="badge border mr-1" v-for="(phone, index) in customer.phone.split(',')"
                :key="`grid-phone-${index}`">
            {{ phone }}
          </span>
        </template>
      </td>
    </tr>
    <tr v-if="!excludeFields.includes('tags')">
      <td class="font-weight-bold">{{ $t('Tags') }}</td>
      <td>
        <template v-if="customer.tags">
          <span class="badge badge-info mr-2" v-for="tag in customer.tags.split(',')">{{ tag }}</span>
        </template>
      </td>
    </tr>
    <tr v-if="!excludeFields.includes('acquisition_source')">
      <td class="font-weight-bold">{{ $t('Acquisition Source') }}</td>
      <td>{{ customer.acquisition_source }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('logo')">
      <td class="font-weight-bold ">{{ $t('Logo') }}</td>
      <td>
        <div v-if="customer.logo" class="file-placeholder">
          <img :src="!customer.logo_uuid ? null : customer.logo.url ? customer.logo.url : customer.logo.base64_src" class="img-fluid" alt=""/>
        </div>
      </td>
    </tr>
    <tr v-if="!excludeFields.includes('vendor_lead_status')">
      <td class="font-weight-bold">{{ $t('Vendor Lead Status') }}</td>
      <td>{{ customer.vendor_lead_status | removeUnderscores | toUpperCaseEveryWord }}</td>
    </tr>
    <tr v-if="!excludeFields.includes('buyer_lead_status')">
      <td class="font-weight-bold">{{ $t('Buyer Lead Status') }}</td>
      <td>{{ customer.buyer_lead_status | removeUnderscores | toUpperCaseEveryWord }}</td>
    </tr>
  </table>
</template>

<script>
  import ClientTierDisplayWidget from "@/core/widgets/ClientTierDisplayWidget.vue";

  export default {
    name: "CustomerInfoTable",
    components: {ClientTierDisplayWidget},
    props: {
      customer: {
        type: Object,
        required: true
      },
      excludeFields: {
        type: Array,
        default: () => []
      },
      enableCustomerLink: {
        type: Boolean,
        default: true
      }
    },
  }
</script>

<style scoped>
  .file-placeholder {
    max-width: 100px;
    height: 100px;
    align-items: center;
    display: flex;
  }

</style>
